import {useState, useContext, useEffect, useRef} from 'react';
import {QRCodeSVG} from 'qrcode.react';

import {AppStateContext} from '../context/AppStateContext';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { GlobalStyles } from '@mui/material';

import nazwaDruzynyInactivePng from '../assets/images/StartScreen/NazwaDruzyny_INactive.png';
import nazwaDruzynyInactiveWebp from '../assets/images/StartScreen/NazwaDruzyny_INactive.webp';
import nazwaDruzynyActivePng from '../assets/images/StartScreen/NazwaDruzyny_active.png';
import nazwaDruzynyActiveWebp from '../assets/images/StartScreen/NazwaDruzyny_active.webp';
import numerTelefonuInactivePng from '../assets/images/StartScreen/NumerTelefonu_INactive.png';
import numerTelefonuInactiveWebp from '../assets/images/StartScreen/NumerTelefonu_INactive.webp';
import numerTelefonuActivePng from '../assets/images/StartScreen/NumerTelefonu_active.png';
import numerTelefonuActiveWebp from '../assets/images/StartScreen/NumerTelefonu_active.webp';
import dalejInactivePng from '../assets/images/StartScreen/Dalej_INactive.png';
import dalejInactiveWebp from '../assets/images/StartScreen/Dalej_INactive.webp';
import dalejActivePng from '../assets/images/StartScreen/Dalej_active.png';
import dalejActiveWebp from '../assets/images/StartScreen/Dalej_active.webp';
import jakGracInactivePng from '../assets/images/StartScreen/jakGrac_INactive.png';
import jakGracInactiveWebp from '../assets/images/StartScreen/jakGrac_INactive.webp';
import jakGracActivePng from '../assets/images/StartScreen/jakGrac_active.png';
import jakGracActiveWebp from '../assets/images/StartScreen/jakGrac_active.webp';
import udostepnijGreInactivePng from '../assets/images/StartScreen/udostepnijGre_INactive.png';
import udostepnijGreInactiveWebp from '../assets/images/StartScreen/udostepnijGre_INactive.webp';
import udostepnijGreActivePng from '../assets/images/StartScreen/udostepnijGre_active.png';
import udostepnijGreActiveWebp from '../assets/images/StartScreen/udostepnijGre_active.webp';
import kontynuujGreInactivePng from '../assets/images/StartScreen/KontynuujGre_INactive.png';
import kontynuujGreInactiveWebp from '../assets/images/StartScreen/KontynuujGre_INactive.webp';
import kontynuujGreActivePng from '../assets/images/StartScreen/KontynuujGre_active.png';
import kontynuujGreActiveWebp from '../assets/images/StartScreen/KontynuujGre_active.webp';
import startInactivePng from '../assets/images/StartScreen/Start_INactive.png';
import startInactiveWebp from '../assets/images/StartScreen/Start_INactive.webp';
import startActivePng from '../assets/images/StartScreen/Start_active.png';
import startActiveWebp from '../assets/images/StartScreen/Start_active.webp';
import zamknijInactivePng from '../assets/images/StartScreen/Zamknij_INactive.png';
import zamknijInactiveWebp from '../assets/images/StartScreen/Zamknij_INactive.webp';
import zamknijActivePng from '../assets/images/StartScreen/Zamknij_active.png';
import zamknijActiveWebp from '../assets/images/StartScreen/Zamknij_active.webp';
import wsteczInactivePng from '../assets/images/StartScreen/Wstecz_INactive.png';
import wsteczInactiveWebp from '../assets/images/StartScreen/Wstecz_INactive.webp';
import wsteczActivePng from '../assets/images/StartScreen/Wstecz_active.png';
import wsteczActiveWebp from '../assets/images/StartScreen/Wstecz_active.webp';
import tutorialVideo from '../assets/images/StartScreen/tutorial_video.mp4';

/* webp ładowany priorytetowo, png jako fallback (część grafik ma tylko jeden format) */
const PlaqueImage = ({webp, png, alt}) => (
    <picture>
        {webp && <source srcSet={webp} type="image/webp" />}
        <img src={png || webp} alt={alt} draggable="false" />
    </picture>
);

/* przycisk-grafika: wersja active pokazywana podczas wciśnięcia */
const ImageButton = ({inactive, active, alt, onClick, className, href}) => {
    const [pressed, setPressed] = useState(false);
    const gfx = pressed ? active : inactive;
    const commonProps = {
        className: `start__btn ${className || ''}`,
        onPointerDown: () => setPressed(true),
        onPointerUp: () => setPressed(false),
        onPointerLeave: () => setPressed(false),
        onClick
    };
    if (href) {
        return (
            <a href={href} {...commonProps}>
                <PlaqueImage webp={gfx.webp} png={gfx.png} alt={alt} />
            </a>
        );
    }
    return (
        <button type="button" {...commonProps}>
            <PlaqueImage webp={gfx.webp} png={gfx.png} alt={alt} />
        </button>
    );
};

const Home = ({socket}) => {
    const [open, setOpen] = useState(false);
    const [teamName, setTeamName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [teamNameError, setTeamNameError] = useState('');
    const [showQR, setShowQR] = useState(false);
    const [showTutorial, setShowTutorial] = useState(false);
    const [step, setStep] = useState(1);
    const [nameFocused, setNameFocused] = useState(false);
    const [phoneFocused, setPhoneFocused] = useState(false);
    const nameInputRef = useRef(null);
    const phoneInputRef = useRef(null);
    const {API_URL, teamToken, setTeamToken, teamData, getTeamData} = useContext(AppStateContext);

    const isQRScan = (() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('qr') === 'true';
    })();
    const [showQRWelcome, setShowQRWelcome] = useState(isQRScan);
    const [qrChecking, setQrChecking] = useState(false);

    useEffect(() => {
        if (!isQRScan) return;
        const autoCheck = async () => {
            setQrChecking(true);
            try {
                const params = new URLSearchParams(window.location.search);
                const token = params.get('token');
                const res = await fetch(`${API_URL}/api/team?teamToken=${token}`);
                const data = await res.json();
                if (!data.error && data.chatHistory && data.chatHistory.length > 0) {
                    params.delete('qr');
                    window.location.href = `/game?${params.toString()}`;
                } else {
                    setQrChecking(false);
                }
            } catch (e) {
                setQrChecking(false);
            }
        };
        autoCheck();
    }, []);

    const handleQROk = async () => {
        setQrChecking(true);
        try {
            const params = new URLSearchParams(window.location.search);
            const token = params.get('token');
            const res = await fetch(`${API_URL}/api/team?teamToken=${token}`);
            const data = await res.json();
            if (!data.error && data.chatHistory && data.chatHistory.length > 0) {
                params.delete('qr');
                const newSearch = params.toString();
                window.location.href = `/game?${newSearch}`;
            } else {
                setQrChecking(false);
            }
        } catch (e) {
            setQrChecking(false);
        }
    };

    useEffect(() => {
        if(teamData && teamData.phoneNumber) {
            setPhoneNumber(teamData.phoneNumber);
        }
        if(teamData && teamData.name) {
            setTeamName(teamData.name);
        }
    }, [teamData]);

    /** zapis danych drużyny; zwraca true przy powodzeniu */
    const submitTeamData = async () => {
        if (!teamName.trim()) {
            setTeamNameError('Nazwa drużyny jest wymagana');
            return false;
        }
        setTeamNameError('');

        const phoneValidationError = validatePhoneNumber(phoneNumber);
        if (phoneValidationError) {
            setPhoneError(phoneValidationError);
            return false;
        }

        if(teamToken && teamName && phoneNumber) {
            try {
                // Wywołaj endpoint do aktualizacji danych drużyny
                const response = await fetch(`${API_URL}/api/team/update`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        token: teamToken,
                        teamName,
                        phoneNumber
                    })
                });

                const data = await response.json();

                if (response.ok) {
                    // Zapisz dane w localStorage
                    localStorage.setItem('teamName', teamName);
                    localStorage.setItem('phoneNumber', phoneNumber);

                    console.log('Dane drużyny zaktualizowane:', data);

                    getTeamData(teamToken);
                    return true;
                } else {
                    console.error('Błąd aktualizacji:', data.error);
                }
            } catch (err) {
                console.error('Błąd komunikacji z serwerem:', err);
            }
        }
        return false;
    }

    const handleDalej = async () => {
        const ok = await submitTeamData();
        if (ok) {
            setStep(2);
        }
    }

    // zapisuje w bazie czas faktycznego rozpoczęcia gry (klik w przycisk Start);
    // keepalive - żeby request zdążył dojść mimo natychmiastowej nawigacji do /game
    const handleStartGame = () => {
        if (!teamToken) return;
        fetch(`${API_URL}/api/team/start-game`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ teamToken }),
            keepalive: true
        }).catch(err => console.error('Błąd zapisu czasu rozpoczęcia gry:', err));
    }

    const handleClose = () => setOpen(false);

    const handleCreateTeam = () => {
        createTeam();
        handleClose();
    }

    const validatePhoneNumber = (phone) => {
        // Usuń wszystkie znaki oprócz cyfr i znaku +
        const cleanPhone = phone.replace(/[^\d+]/g, '');

        // Sprawdź różne formaty polskich numerów
        const phoneRegex = /^(\+48|48|0)[1-9]\d{8}$/;

        if (!phone) {
            return 'Numer telefonu jest wymagany';
        }

        if (phone.length < 9) {
            return 'Numer telefonu jest za krótki';
        }

        if (!phoneRegex.test(cleanPhone)) {
            return 'Nieprawidłowy format numeru (np. +48123456789)';
        }

        return '';
    };

    const handlePhoneChange = (e) => {
        const digits = e.target.value.replace(/[^\d]/g, '');
        const value = '+48' + digits;
        setPhoneNumber(value);

        // Walidacja w czasie rzeczywistym
        const error = validatePhoneNumber(value);
        setPhoneError(error);
    };

    /**
     * po zakupie wywoływany jest endpoint tworzący sesję gry
     * na email/telefon podany przy zakupie wysyłany jest url z tokenem
     * url z tokenem otwiera ekran główny gry gdzie są pola do wpisania numeru telefonu oraz nazwy drużyny
     * (url z tokenem) - sprawdzamy czy token istnieje w bazie
     * po wpisaniu nr tel i kliknięciu "rozpocznij gre" aktualizujemy w bazie dane o drużynie i zaczynamy gre
     * gdy inna osoba wejdzie w url z tokenem - sprawdzamy czy głowny gracz rozpoczał gre i wyswietlamy info (dołącz)
     *
     */
    const createTeam = async () => {
        try {
            const response = await fetch(`${API_URL}/api/team`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ teamName, email: 'mal.charewicz@gmail.com', phone: '+48794432288' })//email i nr tel podany przy rejestracji

            });
            const data = await response.json();
            if (data.token) {
                setTeamToken(data.token);
                localStorage.setItem('teamToken', data.token);
                localStorage.setItem('teamName', teamName);
                window.location.reload();
            }
        } catch (err) {
            console.error('Błąd tworzenia drużyny:', err);
        }

    };

    const btnCss = () => ({
        fontSize: '18px',
        marginTop: '22px',
        color: '#31bdff',
        borderColor: 'rgba(128, 220, 255, .5)',
        padding: '10px 20px',
        textDecoration: 'none',
        '&:hover': {
            borderColor: '#80dcff'
        }
    });

    return (
        <>
            {showQRWelcome && (
                <div style={{
                    position: 'fixed', inset: 0, zIndex: 9999,
                    background: 'rgba(0,0,0,0.82)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        background: '#1a1a1a', borderRadius: '12px',
                        padding: '32px 24px', maxWidth: '300px', width: '90%',
                        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px',
                        border: '1px solid #ffffff40',
                        boxShadow: '0 0 40px rgba(0,0,0,0.7)', textAlign: 'center'
                    }}>
                        <p style={{ color: '#fff', fontSize: '1.1rem', margin: 0, lineHeight: 1.5 }}>
                            Poczekaj na rozpoczęcie gry przez głównego gracza
                        </p>
                        <button
                            disabled={qrChecking}
                            onClick={handleQROk}
                            style={{
                                padding: '10px 36px', borderRadius: '6px', border: 'none',
                                background: 'rgba(100,212,255,0.52)', color: '#fff',
                                fontSize: '1rem', fontWeight: 600, cursor: 'pointer'
                            }}
                        >
                            {qrChecking ? 'Sprawdzam...' : 'OK'}
                        </button>
                    </div>
                </div>
            )}
            <div className='home'>
                <GlobalStyles styles={{ body: { fontSize: '10px' } }} />

                {!teamToken && <div className='home__buttons'>
                    <Button
                        variant="outlined"
                        onClick={handleCreateTeam}
                        sx={btnCss}>
                        TWORZENIE SESJI GRY (po zakupie)
                    </Button>
                    {localStorage.getItem('teamToken') && <a href={`${window.location.origin}/?token=${localStorage.getItem('teamToken')}`} style={{
                        color: '#fff',
                        textDecoration: 'none',
                        fontSize: '14px',
                        marginTop: '20px',
                    }}>{`${window.location.origin}/?token=${localStorage.getItem('teamToken')}`}</a>}
                </div>}

                {teamToken && teamData && step === 1 &&
                <div className='start__panel'>
                    <div
                        className='start__plaque'
                        onClick={() => nameInputRef.current && nameInputRef.current.focus()}
                    >
                        <PlaqueImage
                            webp={nameFocused ? nazwaDruzynyActiveWebp : nazwaDruzynyInactiveWebp}
                            png={nameFocused ? nazwaDruzynyActivePng : nazwaDruzynyInactivePng}
                            alt="Nazwa drużyny"
                        />
                        <div className='start__input-area'>
                            <input
                                ref={nameInputRef}
                                className='start__input'
                                type='text'
                                value={teamName}
                                onChange={e => { setTeamName(e.target.value); if (e.target.value.trim()) setTeamNameError(''); }}
                                onFocus={() => setNameFocused(true)}
                                onBlur={() => setNameFocused(false)}
                                onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
                                maxLength={30}
                                autoComplete='off'
                            />
                        </div>
                        {teamNameError && <div className='start__error'>{teamNameError}</div>}
                    </div>


                    <div
                        className='start__plaque'
                        onClick={() => phoneInputRef.current && phoneInputRef.current.focus()}
                    >
                        <PlaqueImage
                            webp={phoneFocused ? numerTelefonuActiveWebp : numerTelefonuInactiveWebp}
                            png={phoneFocused ? numerTelefonuActivePng : numerTelefonuInactivePng}
                            alt="Numer telefonu"
                        />
                        <div className='start__input-area -phone'>
                            <span className='start__phone-prefix'>+48</span>
                            <input
                                ref={phoneInputRef}
                                className='start__input -phone'
                                type='tel'
                                value={phoneNumber.replace(/^\+48/, '')}
                                onChange={handlePhoneChange}
                                onFocus={() => setPhoneFocused(true)}
                                onBlur={() => setPhoneFocused(false)}
                                onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
                                placeholder='123456789'
                                maxLength={9}
                                autoComplete='off'
                            />
                        </div>
                        {phoneError && <div className='start__error'>{phoneError}</div>}
                    </div>


                    <ImageButton
                        className='-dalej'
                        inactive={{webp: dalejInactiveWebp, png: dalejInactivePng}}
                        active={{webp: dalejActiveWebp, png: dalejActivePng}}
                        alt="Dalej"
                        onClick={handleDalej}
                    />
                </div>
                }

                {teamToken && teamData && step === 2 &&
                <div className='start__panel -step2'>
                    <ImageButton
                        className='-wide'
                        inactive={{webp: jakGracInactiveWebp, png: jakGracInactivePng}}
                        active={{webp: jakGracActiveWebp, png: jakGracActivePng}}
                        alt="Jak grać?"
                        onClick={() => setShowTutorial(true)}
                    />
                    <ImageButton
                        className='-wide'
                        inactive={{webp: udostepnijGreInactiveWebp, png: udostepnijGreInactivePng}}
                        active={{webp: udostepnijGreActiveWebp, png: udostepnijGreActivePng}}
                        alt="Udostępnij grę"
                        onClick={() => setShowQR(true)}
                    />
                    {teamData.chatHistory && teamData.chatHistory.length > 0 ?
                    <ImageButton
                        className='-full'
                        inactive={{webp: kontynuujGreInactiveWebp, png: kontynuujGreInactivePng}}
                        active={{webp: kontynuujGreActiveWebp, png: kontynuujGreActivePng}}
                        alt="Kontynuuj grę"
                        href={`/game?token=${teamToken}`}
                    />
                    :
                    <ImageButton
                        className='-full'
                        inactive={{webp: startInactiveWebp, png: startInactivePng}}
                        active={{webp: startActiveWebp, png: startActivePng}}
                        alt="Start"
                        onClick={handleStartGame}
                        href={`/game?token=${teamToken}`}
                    />
                    }
                    <ImageButton
                        className='-wstecz'
                        inactive={{webp: wsteczInactiveWebp, png: wsteczInactivePng}}
                        active={{webp: wsteczActiveWebp, png: wsteczActivePng}}
                        alt="Wstecz"
                        onClick={() => setStep(1)}
                    />
                </div>
                }

                {/* preload wersji active, żeby nie migały przy pierwszym wciśnięciu */}
                <div style={{ display: 'none' }} aria-hidden="true">
                    <PlaqueImage webp={nazwaDruzynyActiveWebp} png={nazwaDruzynyActivePng} alt="" />
                    <PlaqueImage webp={numerTelefonuActiveWebp} png={numerTelefonuActivePng} alt="" />
                    <PlaqueImage webp={dalejActiveWebp} png={dalejActivePng} alt="" />
                    <PlaqueImage webp={jakGracActiveWebp} png={jakGracActivePng} alt="" />
                    <PlaqueImage webp={udostepnijGreActiveWebp} png={udostepnijGreActivePng} alt="" />
                    <PlaqueImage webp={startActiveWebp} png={startActivePng} alt="" />
                    <PlaqueImage webp={kontynuujGreActiveWebp} png={kontynuujGreActivePng} alt="" />
                    <PlaqueImage webp={wsteczActiveWebp} png={wsteczActivePng} alt="" />
                </div>

                {showTutorial && (
                    <div
                        onClick={() => setShowTutorial(false)}
                        className='gr-code__bg'
                    >
                        <div
                            onClick={e => e.stopPropagation()}
                            className='start__video-container'
                        >
                            <video
                                className='start__video'
                                src={tutorialVideo}
                                controls
                                autoPlay
                                playsInline
                            />
                            <ImageButton
                                className='-zamknij'
                                inactive={{webp: zamknijInactiveWebp, png: zamknijInactivePng}}
                                active={{webp: zamknijActiveWebp, png: zamknijActivePng}}
                                alt="Zamknij"
                                onClick={() => setShowTutorial(false)}
                            />
                        </div>
                    </div>
                )}

                {showQR && (
                    <div
                        onClick={() => setShowQR(false)}
                        className='gr-code__bg'
                    >
                        <div
                            onClick={e => e.stopPropagation()}
                            className='gr-code__container'
                        >
                            <QRCodeSVG
                                value={`${window.location.origin}/?token=${teamToken}&qr=true`}
                                width="220"
                                height="220"
                                fgColor="#ffffff"
                                bgColor="#1a1a1a"
                            />
                            <div className='gr-code__text'>
                                Grę możesz również udostępnić później podczas rozgrywki wchodząc w zakładkę "Pomoc"
                            </div>
                            <ImageButton
                                className='-zamknij'
                                inactive={{webp: zamknijInactiveWebp, png: zamknijInactivePng}}
                                active={{webp: zamknijActiveWebp, png: zamknijActivePng}}
                                alt="Zamknij"
                                onClick={() => setShowQR(false)}
                            />
                        </div>
                    </div>
                )}

                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Utwórz drużynę</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Nazwa drużyny"
                            fullWidth
                            value={teamName}
                            onChange={e => setTeamName(e.target.value)}
                            sx={{
                                '& .MuiInputBase-input': { fontSize: '1.4rem' },
                                '& .MuiInputLabel-root': { fontSize: '1.4rem' }
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} sx={{ fontSize: '1.4rem' }}>Anuluj</Button>
                    </DialogActions>
                </Dialog>

            </div>

        </>

    )
}

export default Home
